var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHtmlcssSkills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 54,
    viewBox: "0 0 60 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#E44F26",
    points: "3.124 44.061 .036 9.427 33.965 9.427 30.874 44.055 16.98 47.907"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#F1662A",
    points: "17.001 44.963 28.228 41.85 30.87 12.259 17.001 12.259"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "17.001 25.104 11.38 25.104 10.992 20.755 17.001 20.755 17.001 16.507 16.986 16.507 6.349 16.507 6.451 17.646 7.495 29.352 17.001 29.352"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "17.001 36.136 16.982 36.141 12.251 34.863 11.949 31.476 9.65 31.476 7.685 31.476 8.28 38.145 16.981 40.56 17.001 40.555"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010101",
    points: "3.193 .015 5.351 .015 5.351 2.148 7.326 2.148 7.326 .015 9.485 .015 9.485 6.474 7.326 6.474 7.326 4.311 5.351 4.311 5.351 6.474 3.193 6.474"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010101",
    points: "12.323 2.157 10.423 2.157 10.423 .015 16.383 .015 16.383 2.157 14.482 2.157 14.482 6.474 12.323 6.474 12.323 2.157"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010101",
    points: "17.329 .015 19.58 .015 20.964 2.285 22.348 .015 24.599 .015 24.599 6.474 22.449 6.474 22.449 3.273 20.964 5.569 20.927 5.569 19.441 3.273 19.441 6.474 17.329 6.474 17.329 .015"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#010101",
    points: "25.673 .015 27.833 .015 27.833 4.339 30.868 4.339 30.868 6.474 25.673 6.474 25.673 .015"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "16.986 25.104 16.986 29.352 22.216 29.352 21.723 34.86 16.986 36.139 16.986 40.558 25.694 38.145 25.758 37.427 26.756 26.245 26.859 25.104 25.715 25.104"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "16.986 16.507 16.986 19.145 16.986 20.744 16.986 20.755 27.232 20.755 27.232 20.755 27.246 20.755 27.331 19.8 27.525 17.646 27.626 16.507"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    transform: "translate(26.008 5.817)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131313",
    d: "M26.596654,1.78870722 L23.7805323,1.78870722 L26.7091255,4.96653992 L26.7091255,6.47920152 L20.6769582,6.47920152 L20.6769582,4.7081749 L23.604981,4.7081749 L20.6769582,1.53022814 L20.6769582,0.0153992395 L26.596654,0.0153992395 L26.596654,1.78870722 Z M19.4812928,1.78870722 L16.6651711,1.78870722 L19.5936502,4.96653992 L19.5936502,6.47920152 L13.5614829,6.47920152 L13.5614829,4.7081749 L16.4898479,4.7081749 L13.5614829,1.53022814 L13.5614829,0.0153992395 L19.4812928,0.0153992395 L19.4812928,1.78870722 Z M12.4355133,1.86068441 L9.39673004,1.86068441 L9.39673004,4.63403042 L12.4355133,4.63403042 L12.4355133,6.47920152 L7.23695817,6.47920152 L7.23695817,0.0153992395 L12.4355133,0.0153992395 L12.4355133,1.86068441 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#1572B6",
    points: "3.096 44.063 .008 9.43 33.938 9.43 30.847 44.058 16.952 47.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#33A9DC",
    points: "16.973 44.966 28.201 41.853 30.842 12.262 16.973 12.262"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.274 16.198)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "10.699 8.612 16.32 8.612 16.708 4.262 10.699 4.262 10.699 .014 10.714 .014 21.35 .014 21.249 1.154 20.205 12.859 10.699 12.859"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "10.725 19.643 10.706 19.648 5.975 18.371 5.673 14.983 3.374 14.983 1.409 14.983 2.004 21.652 10.705 24.068 10.725 24.063"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "15.959 12.679 15.447 18.368 10.71 19.647 10.71 24.066 19.418 21.652 19.482 20.935 20.221 12.679"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "10.714 .014 10.714 2.652 10.714 4.252 10.714 4.262 .467 4.262 .467 4.262 .454 4.262 .369 3.307 .175 1.154 .074 .014"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#EBEBEB",
    points: "10.699 8.612 10.699 11.25 10.699 12.849 10.699 12.86 6.042 12.86 6.042 12.86 6.029 12.86 5.943 11.905 5.75 9.752 5.648 8.612"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtmlcssSkills);
export default __webpack_public_path__ + "static/media/htmlcss-skills.c050f36973a221adbf2d5d0136aca1b4.svg";
export { ForwardRef as ReactComponent };